module.exports = __webpack_public_path__ + "img/left-image.87e9735b.png";